import { render, staticRenderFns } from "./SenderInfoEdit.vue?vue&type=template&id=3b77aa5b"
import script from "./SenderInfoEdit.vue?vue&type=script&lang=js"
export * from "./SenderInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./SenderInfoEdit.vue?vue&type=style&index=0&id=3b77aa5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports